// extracted by mini-css-extract-plugin
module.exports = {"confetti":"Confetti-module--confetti--XB1JE","confettiFall":"Confetti-module--confetti--fall--30tU0","confettiAnimation":"Confetti-module--confettiAnimation--3DhBH"};